import React, { useEffect, useState } from 'react'
import { Form } from './styles';
import FormInput from "../input";

const SalaryData = ({items, formMode,t, salaryValues, errorInput, handleSalaryChange }) => {
    

  return (
    <Form className={`${formMode ?? ""} sub`}>
                        {items.attributes?.length > 0 &&
                          items.attributes.map((item,index) => {
                            let dynamicClass = "";
                    if (item.condition) {
                      if (salaryValues[item.condition.item] === item.condition.if) {
                        dynamicClass = item.condition.then;
                      } else {
                        dynamicClass = item.condition.else;
                      }
                    }
                    return <FormInput dynamicClass={dynamicClass} formValues={salaryValues} placeholder={item.placeHolder} key={`input` + index} id={index} {...item} onChange={handleSalaryChange} value={salaryValues[item.name]} />;
                          })}

                          {/* <div style={{width:'100%', display:'flex', justifyContent:'center',alignItems:'center'}}>
                            <FormInput disabled={submitDisabled} type="submit" name="submit" value={t("submit")} onChange={submitChange} />
                          </div> */}
            </Form>
  )
}

export default SalaryData